module.exports = __webpack_public_path__ + "static/media/hands_shaking_icon.fa7b698a.svg";